import { styled } from 'styled-components';
import { Menu as MantineMenu } from '@mantine/core';
import { textSmallSemiBold } from '../../Typography';

export const MenuContainer = styled(MantineMenu)``;

export const DropDownContainer = styled(MantineMenu.Dropdown)`
  --menu-item-hover: var(--black-500);

  &.popupMenuDropdown {
    ${textSmallSemiBold};
    background: var(--black-400);
    border-color: var(--border-color-default);
    border-radius: var(--radius-400);

    a, button {
      border-radius: var(--radius-200);
    }
  }
`;
